import { render, staticRenderFns } from "./AppChecklistsAnswersList.vue?vue&type=template&id=019e5cfa&"
import script from "./AppChecklistsAnswersList.vue?vue&type=script&lang=js&"
export * from "./AppChecklistsAnswersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports